import React from "react";
import { useSiteContent } from "@/lib/siteContent";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FaqPage() {
  const sc = useSiteContent();
  const items = sc?.sss || [];
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="faq-page">
      <h1 className="font-head text-3xl font-bold text-slate-900 mb-6">Sık Sorulan Sorular</h1>
      {!items.length ? <p className="text-slate-500">Henüz soru eklenmedi.</p> : (
        <Accordion type="single" collapsible className="bg-white border rounded-xl px-4">
          {items.map((x, i) => (
            <AccordionItem key={i} value={`q${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left">{x.s}</AccordionTrigger>
              <AccordionContent className="whitespace-pre-line text-slate-600">{x.c}</AccordionContent>
            </AccordionItem>))}
        </Accordion>)}
    </div>
  );
}
